export { default } from './Card';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Card/index.js
// module id = 656
// module chunks = 0